import moment from "moment";
import { Constants } from "../utils/Constants";
import { fetchWithAuth } from "../utils/fetch/FetchWithAuth";
import { prepareBaseGetListParams } from "../utils/fetch/PrepareBaseGetListParams";
import { prepareEnumSearchParams } from "../utils/fetch/PrepareEnumSearchParams";
import { FILTER_TYPES } from "../component/datatable/DataTable";

export const TransactionService = { 

    getList: (criteria) => {
        const params = prepareBaseGetListParams(criteria);
        if (criteria.period) {
            params.append('period_from', criteria.period.from);
            params.append('period_to', criteria.period.to);
            params.append('period_type', criteria.period.periodType?.toUpperCase());
        }
        const url = `/portal/transactions?${params.toString()}`;
        return fetchWithAuth(url, { method: 'GET' });
    },
    getStatusList: () => {
        return fetchWithAuth('/portal/transactions/status-list', { method: 'GET' });
    },
    getPaymentMethodList: () => {
        return fetchWithAuth('/portal/transactions/payment-method-list', { method: 'GET' });
    },
    getDetails: (transactionId) => {
        return fetchWithAuth(`/portal/transactions/${transactionId}`, { method: 'GET' });
    },
    getOperatorList: () => {
        return fetchWithAuth('/portal/transactions/operator-list', { method: 'GET' });
    },

    getMerchantList: () => {
        return fetchWithAuth('/portal/transactions/merchant-list', { method: 'GET' });
    },
    getLocationList: () => {
        return fetchWithAuth('/portal/transactions/location-list', { method: 'GET' });
    },
    getProductList: () => {
        return fetchWithAuth('/portal/transactions/product-list', { method: 'GET' });
    },
    getProductCategoryList: () => {
        return fetchWithAuth('/portal/transactions/product-category-list', { method: 'GET' });
    },
    getMaxTransactionCountForSalesByProduct: (period) => {
        const params = new URLSearchParams();        
        const formatDate = ((value) => moment(value).utc().format(Constants.DATE_TIME_FORMAT_GET));
        params.append('period_from', formatDate(period.from));
        params.append('period_to', formatDate(period.to));
        const url = `/portal/transactions/sales-by-product/max-transaction-count?${params.toString()}`;
        return fetchWithAuth(url, { method: 'GET' });
    },
    getMaxTransactionCountForSalesByLocation: (period) => {
        const params = new URLSearchParams();
        const formatDate = ((value) => moment(value).utc().format(Constants.DATE_TIME_FORMAT_GET));
        params.append('period_from', formatDate(period.from));
        params.append('period_to', formatDate(period.to));

        const url = `/portal/transactions/sales-by-location/max-transaction-count?${params.toString()}`;
        return fetchWithAuth(url, { method: 'GET' });
    },
    getTopSalesByLocation: (period,criteria) => {
        const params = prepareBaseGetListParams(criteria);
        params.append('period_type', period.periodType?.toUpperCase());
        const formatDate = ((value) => moment(value).utc().format(Constants.DATE_TIME_FORMAT_GET));
        params.append('period_from', formatDate(period.from));
        params.append('period_to', formatDate(period.to));
        const url = `/portal/transactions/sales-by-location?${params.toString()}`;
        return fetchWithAuth(url, { method: 'GET' });
    },
    getTopSalesByProduct: (period,criteria) => {
        const params = prepareBaseGetListParams(criteria);
        params.append('period_type', period.periodType?.toUpperCase());
        const formatDate = ((value) => moment(value).utc().format(Constants.DATE_TIME_FORMAT_GET));
        params.append('period_from', formatDate(period.from));
        params.append('period_to', formatDate(period.to));
        const url = `/portal/transactions/sales-by-product?${params.toString()}`;
        return fetchWithAuth(url, { method: 'GET' });
    },
    getFinancialReport: (from, to, locationId) => {

        const formatDate = ((value) => moment(value).utc().format(Constants.DATE_TIME_FORMAT_GET));
        
        const params = new URLSearchParams();
        params.append('from', formatDate(from));
        params.append('to', formatDate(to));
        if (locationId) {
            params.append('location_id', locationId);
        }
        const url = `/portal/transactions/financial-report?${params.toString()}`;
        return fetchWithAuth(url, { method: 'GET' });
    },
    getFinancialReportPrevRevenue: (from, to, periodType, locationId) => {
        const formatDate = ((value) => moment(value).utc().format(Constants.DATE_TIME_FORMAT_GET));
        const params = new URLSearchParams();
        params.append('from', formatDate(from));
        params.append('to', formatDate(to));
        params.append('period_type', periodType?.toUpperCase());
        if (locationId) {
            params.append('location_id', locationId);
        }        
        const url = `/portal/transactions/financial-report/prev-revenue?${params.toString()}`;
        return fetchWithAuth(url, { method: 'GET' });
    },
    getSalesOverview: (period, deviceId, criteria) => {
        const formatDate = ((value) => moment(value).utc().format(Constants.DATE_TIME_FORMAT_GET));
        const params = prepareBaseGetListParams(criteria, false); 
        params.append('period_from', formatDate(period.from));
        params.append('period_to', formatDate(period.to));
        params.append('period_type', period.periodType?.toUpperCase());
        if (deviceId) {
            params.append('device_id', deviceId);
        }
        
        const url = `/portal/transactions/sales-overview?${params.toString()}`;
        return fetchWithAuth(url, { method: 'GET' });
    },    
    getCashTransactions: (criteria, onlyLastOperation = false, enums = []) => {
        const params = prepareBaseGetListParams(criteria);
        prepareEnumSearchParams(criteria.baseQuery, params, enums);
        if (onlyLastOperation) {
            params.append('only_last_operation', 'true');
        }
        return fetchWithAuth(`/portal/transactions/cash-transactions?${params.toString()}`, { method: 'GET' });
    },
 

}

